import { ChangeDetectionStrategy, Component } from '@angular/core';

import { PageSlotModule } from '@spartacus/storefront';

import { AbstractPageComponent } from '@seb/web-common/core/templates/abstract-page/abstract-page.component';

@Component({
  selector: 'wc-recipe-home-page',
  templateUrl: './recipe-home-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [PageSlotModule]
})
export class RecipeHomePageComponent extends AbstractPageComponent {
  constructor() {
    super();

    this.eagerLoadingSlot = 'Body1';
  }
}
